module.exports = __webpack_public_path__ + "img/newchris-72.b197406f.jpg";